import { Reducer } from "redux";

import { ApplicationStatefulModule } from "@multiweb/types/react";
import { NAME } from "./constants";
import { reducer } from "./reducer";
import { FormsMapState } from "./types";

export {
    createDeleteFormAction,
    createInitFormAction,
} from "./actions";
export {
    DELETE_FORM,
    INIT_FORM,
} from "./constants";
export {
    getFormExtendedProperties,
    getFormInstance,
    getFormTags,
} from "./selector";
export {
    FormsMapState,
    IDeleteFormAction,
    IInitFormAction,
} from "./types";

export const formsModule: ApplicationStatefulModule<typeof NAME, Reducer<FormsMapState>> = {
    NAME,
    reducer,
};
